import { apiClientPostRequest } from '../lib/backendRequest';

const uploadApi = (accessToken, countryCode) => ({
  /**
   *
   * @param {string} mediaType "photo"
   * @param {Array} items array of items to get media id
   */
  async getRemoteUrls(mediaType, items = []) {
    const request = async (totalNumberOfItems, pendingItems, fetchedItems = []) => {
      if (fetchedItems.length === totalNumberOfItems || pendingItems.length === 0) {
        return { data: fetchedItems };
      }

      const { mimeType } = pendingItems[0];
      const urls = pendingItems.filter(item => item.mimeType === mimeType).map(item => item.url);

      try {
        const response = await apiClientPostRequest(
          `api/v1/upload/media/${mediaType}/remote_urls`,
          {
            mime_type: mimeType,
            location_country_alpha2: countryCode,
            urls,
          },
          {
            Authorization: `Token ${accessToken}`,
          },
        );

        let newPendingItems = [...pendingItems];
        const newFetchedItems = [...fetchedItems];

        const json = await response.json();

        json.data.media.forEach(medium => {
          newPendingItems = newPendingItems.filter(item => item.url !== medium.source_url);
          newFetchedItems.push({
            url: medium.source_url,
            id: medium.id,
          });
        });

        return request(totalNumberOfItems, newPendingItems, newFetchedItems);
      } catch (e) {
        return { error: e.code };
      }
    };

    return request(items.length, items);
  },

  /**
   *
   * @param {number} orderId
   * @param {Array<number>} ids medias
   */
  async remoteUpload(orderId, ids = []) {
    if (ids.length === 0) {
      return { data: true };
    }

    try {
      await apiClientPostRequest(
        `api/v1/orders/${orderId}/remote_upload`,
        {
          location_country_alpha2: countryCode,
          ids,
        },
        {
          Authorization: `Token ${accessToken}`,
        },
      );

      return { data: true };
    } catch (e) {
      return { error: e.code };
    }
  },
});

export default uploadApi;
